import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Linkedin, Twitter } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import Logo from './Logo';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#0B1220] border-t border-[#1F2A3A] mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1">
            <div className="mb-4">
              <Logo size="default" />
            </div>
            <p className="text-[#8A90A0] text-sm leading-relaxed">
              {t('footer.tagline')}
            </p>
            <p className="text-[#8A90A0] text-sm mt-2">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-[#8A90A0] hover:text-yamai-cyan-500 transition-colors text-sm">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-[#8A90A0] hover:text-yamai-cyan-500 transition-colors text-sm">
                  {t('nav.projects')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-[#8A90A0] hover:text-yamai-cyan-500 transition-colors text-sm">
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#8A90A0] hover:text-yamai-cyan-500 transition-colors text-sm">
                  {t('nav.contact')}
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-[#8A90A0] hover:text-yamai-cyan-500 transition-colors text-sm">
                  {t('nav.faq')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Projects */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.projects')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/projects/cardio" className="text-[#8A90A0] hover:text-yamai-cyan-500 transition-colors text-sm">
                  Yamai Cardio
                </Link>
              </li>
              <li>
                <Link to="/projects/neuro" className="text-[#8A90A0] hover:text-yamai-cyan-500 transition-colors text-sm">
                  Yamai Neuro
                </Link>
              </li>
              <li>
                <Link to="/projects/derma" className="text-[#8A90A0] hover:text-yamai-cyan-500 transition-colors text-sm">
                  Yamai Derma
                </Link>
              </li>
              <li>
                <Link to="/projects/healthnet" className="text-[#8A90A0] hover:text-yamai-cyan-500 transition-colors text-sm">
                  Yamai HealthNet
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.contact')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-sm">
                <Mail size={16} className="text-yamai-cyan-500 mt-1 flex-shrink-0" />
                <a href="mailto:info@yamai.tech" className="text-[#8A90A0] hover:text-yamai-cyan-500 transition-colors">
                  info@yamai.tech
                </a>
              </li>
              <li className="flex items-start space-x-2 text-sm">
                <MapPin size={16} className="text-yamai-cyan-500 mt-1 flex-shrink-0" />
                <span className="text-[#8A90A0]">
                  Breda, Noord-Brabant<br />{t('footer.location')}
                </span>
              </li>
            </ul>
            <div className="flex space-x-3 mt-4">
              <a
                href="#"
                className="w-8 h-8 rounded-lg bg-[#1F2A3A] flex items-center justify-center hover:bg-gradient-to-r hover:from-yamai-cyan-500 hover:to-yamai-purple-500 transition-all"
              >
                <Linkedin size={16} className="text-white" />
              </a>
              <a
                href="#"
                className="w-8 h-8 rounded-lg bg-[#1F2A3A] flex items-center justify-center hover:bg-gradient-to-r hover:from-yamai-cyan-500 hover:to-yamai-purple-500 transition-all"
              >
                <Twitter size={16} className="text-white" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-[#1F2A3A] flex flex-col md:flex-row justify-between items-center">
          <p className="text-[#8A90A0] text-sm">
            © {new Date().getFullYear()} Yamai B.V. {t('footer.rights')}
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/privacy" className="text-[#8A90A0] hover:text-yamai-cyan-500 transition-colors text-sm">
              {t('footer.privacy')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;